import Feedback from '@/apps/Feedback'
import React from 'react'

const FeedbackBody = (): React.ReactElement => {
  return <Feedback />
}

export default FeedbackBody
